import { Outlet } from "react-router-dom";

import AppBackButton from "../../components/global/GoBack/AppBackButton";

export default () => {
  return (
    <>
      <AppBackButton containerClassName="flex w-full justify-start px-6 pt-6" />
      <Outlet />
    </>
  );
};
